import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "lowTitle text-cyan" }
const _hoisted_6 = { class: "lowTitle text-cyan" }
const _hoisted_7 = { class: "lowTitle text-cyan" }
const _hoisted_8 = { class: "lowTitle text-cyan" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_bank_account_data = _resolveComponent("bank-account-data")!

  return (_ctx.localValue)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Modalità pagamento",
              text: "Modalità pagamento"
            })
          ]),
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.modalitaPagamento) = $event))
          }, [
            _hoisted_3,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalitaPagamentos, (item, i) => {
              return (_openBlock(), _createElementBlock("option", {
                key: i,
                value: item.name
              }, _toDisplayString(item.name), 9, _hoisted_4))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.localValue.modalitaPagamento]
          ])
        ]),
        (_ctx.details)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.details.methodType == 'WireTransfer')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Dati bancari",
                        text: "Dati bancari"
                      })
                    ]),
                    _createVNode(_component_bank_account_data, {
                      item: _ctx.localValue.bankAccountData
                    }, null, 8, ["item"])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.details.methodType == 'Email')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Email",
                        text: "Email"
                      })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.paypalEmail) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.localValue.paypalEmail]
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.details.methodType == 'Crypto')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Address",
                        text: "Address"
                      })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localValue.cryptoAddress) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.localValue.cryptoAddress]
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.details.methodType == 'CardNumber')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Numero carta",
                        text: "Numero carta"
                      })
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localValue.revolutNumber) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.localValue.revolutNumber]
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}